<template>
  <v-container fluid>
    <v-row class="mb-0">
      <v-col>
        <h1>Документы пациента</h1>
      </v-col>

      <v-col align="right">
        <!--        <modal depressed icon="add" title="Добавить документ" name="Документ" component="add-document"></modal>-->
        <v-btn depressed color="primary" title="title" @click.prevent="addDocument">
          <v-icon left>add</v-icon>
          Документ
        </v-btn>
      </v-col>
    </v-row>

    <patient-header />
    <document-list />
  </v-container>
</template>

<script>
import DocumentList from "./components/DocumentList";
import Modal from "@/components/Modal";
import AddDocument from "@/modules/documents/add-document/AddDocument.vue";
import "@/plugins/crypto-pro-loader.js";
import PatientHeader from "@/components/PatientHeader";
export default {
  components: {
    Modal,
    DocumentList,
    PatientHeader,
  },
  methods: {
    addDocument() {
      this.$dialog.showAndWait(AddDocument, { width: "600px", persistent: true });
    },
  },
};
</script>

<style></style>
